import React from "react";
import PropTypes from "prop-types";

/**
 * 인증 셀러 뱃지
 * @param className
 * @param title
 * @returns {JSX.Element}
 * @constructor
 */
export default function CertifiedSellerBadge({ className = "", title = "인증 셀러" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      width="16"
      height="16"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.9865 0.8637C7.5705 0.366095 8.42988 0.366047 9.01385 0.8637L10.0646 1.75921C10.3148 1.97236 10.6257 2.10121 10.9533 2.12737L12.3293 2.23772C13.094 2.29875 13.7017 2.90566 13.7629 3.67034L13.8722 5.04729C13.8985 5.37491 14.0282 5.68581 14.2414 5.93597L15.1359 6.98675C15.6336 7.57074 15.6336 8.4301 15.1359 9.01409L14.2414 10.0649C14.0281 10.3151 13.8984 10.6258 13.8722 10.9535L13.7629 12.3295C13.7018 13.0944 13.0941 13.7021 12.3293 13.7631L10.9533 13.8725C10.6256 13.8987 10.3149 14.0284 10.0646 14.2416L9.01385 15.1362C8.42985 15.6338 7.5705 15.6338 6.9865 15.1362L5.93572 14.2416C5.68557 14.0284 5.37467 13.8987 5.04705 13.8725L3.6701 13.7631C2.90541 13.7019 2.29851 13.0943 2.23748 12.3295L2.12713 10.9535C2.10096 10.6259 1.97212 10.3151 1.75896 10.0649L0.863456 9.01409C0.365803 8.43012 0.365852 7.57074 0.863456 6.98675L1.75896 5.93597C1.97213 5.68582 2.10089 5.37489 2.12713 5.04729L2.23748 3.67034C2.29868 2.9058 2.90556 2.29893 3.6701 2.23772L5.04705 2.12737C5.37465 2.10114 5.68558 1.97238 5.93572 1.75921L6.9865 0.8637ZM11.0461 4.78558C10.7435 4.57621 10.3279 4.65113 10.1183 4.95354L6.97381 9.49456L5.88103 7.91643C5.67132 7.61424 5.25581 7.53903 4.9533 7.74847C4.65096 7.95809 4.576 8.37362 4.78533 8.6762L6.42596 11.0463C6.55038 11.226 6.75525 11.3332 6.97381 11.3334C7.19257 11.3334 7.39811 11.2262 7.52264 11.0463L11.215 5.71331C11.4245 5.41065 11.3486 4.99518 11.0461 4.78558Z"
        fill="#009EFF"
      />
    </svg>
  );
}

CertifiedSellerBadge.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};
